module.exports = __webpack_public_path__ + "static/media/juicyberries.1accb7e4.webp";